// extracted by mini-css-extract-plugin
export var walkingImageProject = "walkingTours-module--walking-image-project--ed5c6";
export var walkingTourContent = "walkingTours-module--walking-tour-content--011ef";
export var walkingTourImage = "walkingTours-module--walking-tour-image--6d0b4";
export var walkingTourItem = "walkingTours-module--walking-tour-item--5b078";
export var walkingTourText = "walkingTours-module--walking-tour-text--6dfe2";
export var walkingTours = "walkingTours-module--walking-tours--1573d";
export var walkingToursWrapper = "walkingTours-module--walking-tours-wrapper--e6ffc";